import { Stack } from "@mui/joy";
import React from "react";
import FullPageContainer from "./FullPageContainer";
import { theme } from "styles/theme";
import useSafeAreaColor from "hooks/useSafeAreaColor";

export default function DefaultPage({
  content,
  backgroundColor = theme.vars.palette.Background.Level1,
}: {
  content: React.ReactNode;
  backgroundColor?: string;
}) {
  useSafeAreaColor(backgroundColor);

  return (
    <FullPageContainer hasFooter={false} backgroundColor={backgroundColor}>
      <Stack
        flexGrow={1}
        justifyContent="center"
        sx={{ width: "100%", px: "20px" }}
      >
        {content}
      </Stack>
    </FullPageContainer>
  );
}
